import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setShowHiveModalReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showHiveModal = action.payload;
  });
};

export default setShowHiveModalReducer;
